// extracted by css-extract-rspack-plugin
export default {"emailPages__container":"emailPages__container__NeEpY","emailPages__content":"emailPages__content__jIbAr"};